import { Paper, styled } from '@mui/material';
import Colors from '../../entities/colors';
import background from '../../assets/background.svg';
import logo from '../../assets/logo.png';
import useStyles from './styles';
import Spacer from '../../components/Spacer';

interface UnauthorizedProps {
  children: JSX.Element | JSX.Element[];
}

export const Container = styled(Paper)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  width: '100%',
  height: '100%',
  backgroundImage: `url(${background})`,
  backgroundColor: Colors.N200,
  justifyContent: 'center',
  alignItems: 'center',
});

const UnauthorizedLayout = ({ children }: UnauthorizedProps): JSX.Element => {
  const styles = useStyles();

  return (
    <Container>
      <div className={styles.logo}>
        <img src={logo} alt="Apepe Manager" style={{ maxWidth: '160px' }} />
      </div>
      <Spacer />
      {children}
      <Spacer />
    </Container>
  );
};

export default UnauthorizedLayout;
